require('../../modules/es.object.get-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/get-prototype-of.js
// module id = 1001
// module chunks = 0